import { render, staticRenderFns } from "./channel.history.vue?vue&type=template&id=2d092e6e&scoped=true"
import script from "./channel.history.vue?vue&type=script&setup=true&lang=js"
export * from "./channel.history.vue?vue&type=script&setup=true&lang=js"
import style0 from "./channel.history.vue?vue&type=style&index=0&id=2d092e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d092e6e",
  null
  
)

export default component.exports